import type { InsuranceParamsTravelDto, InsuranceParamsTravelDto as Step1FormValues } from 'BrokerTsLib/src/dtos'
import { useNavigate } from 'react-router-dom'

import { Container } from '../../../components/Container'
import { Loading } from '../../../components/Loading'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { Step1Form } from '../../../containers/cestovko/Step1Form'
import { StepsContent } from '../../../context/StepsContext'
import { useSaveInsuranceParams, useUpdateLastWizardStep } from '../../../hooks/useWizard'
import { useInsuranceParamsContext } from '../../../layouts/Wizard'

export const Step1 = () => {
  const navigate = useNavigate()

  const { insuranceParams, insuranceParamsId: paramsId, refetchInsuranceParams, error, isLoadingData } = useInsuranceParamsContext()
  const { mutateAsync: updateStep } = useUpdateLastWizardStep()
  const { mutateAsync: saveInsuranceParams } = useSaveInsuranceParams()

  const handleSubmit = (values: Step1FormValues) =>
    saveInsuranceParams(values)
      .then((response) => {
        if (values.nextPage == 'next') {
          if ((insuranceParams?.generalParams.lastWizardStep ?? 1) == 1)
            return updateStep({ paramsId: Number(response?.data), step: 2, stepsStep: 'cestovko' })
              .then(refetchInsuranceParams)
              .then(() => navigate(`/cestovko/wizard/2/${response?.data}`))
          else refetchInsuranceParams().then(() => navigate(`/cestovko/wizard/2/${response?.data}`))
        } else {
          refetchInsuranceParams().then(() => navigate(`/cestovko/wizard/1/${response?.data}`))
        }
      })

  return (
    <Section>
      <Container>
        {isLoadingData && <Loading large={true} />}

        {(!paramsId || insuranceParams) &&
          <StepsContent step={1}>
            <Steps icon="beach" />

            <Step1Form onSubmit={handleSubmit} data={insuranceParams as InsuranceParamsTravelDto} />
          </StepsContent>
        }

        <WizardForbiddenMessage />
      </Container>
    </Section>
  )
}
